import TileLayer from "ol/layer/Tile";
import { TileWMS } from "ol/source";
import { FC, useEffect, useState } from "react";
import "../../../App.css";
import toGroupLayers from "../weatherLayer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGauge, faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { LocationMarkerPopup } from "../../MainWindow";
import Tooltip from "@mui/material/Tooltip";
import { getGlobalLayer } from "../../MainWindow";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";
import { ecmf, ICON } from "../weatherLayer";
import { ThemeProvider, useTheme } from "../../../theme/ThemeContext";
import { useMenu } from "../../../roundMenuContext/roundMenuContext";
import {
  ecmf3hEnd,
  ecmf3hInterval,
  ecmf3hStart,
  ecmf6hEnd,
  ecmf6hInterval,
  ecmf6hStart,
  icon1hInterval,
  icon1hStart,
  icon1hEnd,
  icon3hInterval,
  icon3hStart,
  icon3hEnd,
  layerStartDate,
} from "../../../TimeLine/BackgroundMapTimeLine/TimeLineService";
import addPressureLayerGroup, {
  allPressuredMap,
  allPressuredMapICON,
  pressureMapECMWF,
  pressureMapICON,
} from "./pressureLayer";

interface PressureLayerProps {
  timeLineHour: string;
  timeLineDate: string;
  selectModel: string;
  setTimeLayer: (layer: string) => void;
}

let isButtonClicked: boolean = false;
let pressureMap: Map<string, ImageLayer<ImageWMS>> = new Map();
let pressureMapIcon: Map<string, ImageLayer<ImageWMS>> = new Map();
let isPressureClicked: string = "";
let lastLayer: ImageLayer<ImageWMS> | undefined;

const Pressure: React.FC<PressureLayerProps> = ({
  timeLineHour,
  timeLineDate,
  selectModel,
  setTimeLayer,
}) => {
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const [timeLineCounter, setTimeLineCounter] = useState<number>(0);
  const [hoveredAir, setHoveredAir] = useState(false);
  const { theme } = useTheme();
  const { menu } = useMenu();

  const [hoveredPressure, setHoveredPressure] = useState(false);
  const [isCheckedPressure, setIsCheckedPressure] = useState(false);
  const handleChangePressureToggle = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isChecked = event.target.checked;
    setIsCheckedPressure(event.target.checked);
    setIsClicked((prevState) => !prevState);
    if (isChecked) {
      isPressureClicked = "pressure";
      airIconClick(); // Call airIconClick when the switch is toggled to true
      LocationMarkerPopup("pressure");
      setTimeLayer("pressurenot");
    } else {
      isPressureClicked = "";
      LocationMarkerPopup("pressure not");
      setTimeLayer("pressure");
      airIconClick();
    }
  };

  useEffect(() => {
    if (isPressureClicked === "pressure") {
      isButtonClicked = true;
      airIconClick();
    }
  }, [timeLineHour, timeLineDate]);

  function formatTimestamp(timestamp: number): string {
    const date = new Date(timestamp * 1000); // Multiply by 1000 to convert to milliseconds
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}-${hour}:${minute}`;
  }

  function parseDateString(dateString: string): string | null {
    const offsetMinutes = new Date().getTimezoneOffset();

    const dateRegex = /^(\d{4})-(\d{2})-(\d{2})-(\d{2}):(\d{2})$/;
    const match = dateString.match(dateRegex);
    if (!match) {
      console.error("Invalid date format:", dateString);
      return null;
    }
    const [, year, month, day, hour, minute] = match;
    const date = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute)
    );
    date.setMinutes(date.getMinutes() + offsetMinutes);
    const formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}-${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
    return formattedDate;
  }

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (ecmf6hStart && ecmf6hStart !== 0) {
      setIsReady(true); // Set ready state to true when ecmf6hStart is valid
    }
  }, [ecmf6hStart]);

  const resultMap = new Map<number, string>();
  const date = new Date();
  const formattedDate = date.toLocaleDateString("en-CA");

  useEffect(() => {
    if (!isReady) return;

    if (isPressureClicked === "pressure") {
      setIsClicked(true);

      let i = 0;
      for (; i <= 48; i++) {
        const value = ecmf3hStart + i * ecmf3hInterval;
        if (value > ecmf3hEnd) break;
        resultMap.set(i, formatTimestamp(value));
      }

      for (let j = i; j <= 64; j++) {
        const value = ecmf6hStart + (j - 48) * ecmf6hInterval;
        if (value > ecmf6hEnd) break;
        resultMap.set(j, formatTimestamp(value));
      }

      try {
        for (let i = 0; i <= ecmf.size; i++) {
          let dateBefore = resultMap.get(i) ?? "";
          let dayPass = parseDateString(dateBefore);

          var layers = new ImageLayer({
            source: new ImageWMS({
              url: "https://wms.tecxal.com/visura/weatherwmseagle",
              params: {
                LAYERS: `weather:${layerStartDate}_ecmwf_${dayPass}:00_msl`,
                STYLES: "weather:pressure",
              },
              serverType: "geoserver",
              projection: "EPSG:4326",
            }),
          });
          layers.set("name", "pressure");
          const key = resultMap.get(i);
          if (key !== undefined) {
            pressureMap.set(key, layers);
          }

          allPressuredMap("pressureEcmwf", pressureMap);
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    }
    //  else if (weatherlayerState === "flood") {
    //   setIsClicked(false);
    //   LocationMarkerPopup("airPressure");
    // } else {
    //   setIsClicked(false);
    // }
  }, [isPressureClicked, isClicked, isReady]);

  useEffect(() => {}, [isButtonClicked]);

  useEffect(() => {}, [isClicked]);

  const [isIconReady, setIconReady] = useState(false);

  useEffect(() => {
    if (icon3hStart && icon3hStart !== 0) {
      setIconReady(true);
    }
  }, [icon3hStart]);

  const resultIconMap = new Map<number, string>();

  useEffect(() => {
    if (!isIconReady) return;
    if (selectModel === "ICON") {
      let i = 0;
      for (; i <= 180; i++) {
        const value = icon1hStart + i * icon1hInterval;
        resultIconMap.set(i, formatTimestamp(value));
      }
      try {
        for (let i = 0; i <= ICON.size; i++) {
          let dateBefore = resultIconMap.get(i) ?? "";
          let dayPass = parseDateString(dateBefore);

          var layers = new ImageLayer({
            source: new ImageWMS({
              url: "https://wms.tecxal.com/visura/weatherwmseagle",
              params: {
                LAYERS: `weather:${layerStartDate}_ecmwf_${dayPass}:00_msl`,
                STYLES: "weather:pressure",
              },
              serverType: "geoserver",
              projection: "EPSG:4326",
            }),
          });
          layers.set("name", "pressure");
          pressureMapIcon.set(i.toString(), layers);
          allPressuredMapICON("pressureIcon", pressureMapIcon);
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    }
  }, [selectModel, isIconReady]);

  const airIconClick = async () => {
    try {
      setTimeout(() => {
        let pressureLayerMap;
        if (selectModel === "ECMWF") {
          pressureLayerMap = pressureMapECMWF.get("pressureEcmwf");
        } else if (selectModel === "ICON") {
          pressureLayerMap = pressureMapICON.get("pressureIcon");
        }
        if (pressureLayerMap) {
          const layer = pressureLayerMap.get(timeLineDate + "-" + timeLineHour);
          lastLayer = layer;
          if (layer) {
            getGlobalLayer(layer);
            if (isPressureClicked === "pressure") {
              addPressureLayerGroup(layer, isClicked, "pressure");
            }
          }
          if (isPressureClicked === "" && lastLayer) {
            addPressureLayerGroup(lastLayer, true, "pressure");
          }
        }
        // setWeatherLayer("pressure");
      }, 500);
    } catch (error) {
      console.error("Error fetching API data:", error);
    }
  };

  return (
    <>
      <div className="leftsidemenulist-btn-cover">
        <div
          onMouseEnter={() => setHoveredPressure(true)}
          onMouseLeave={() => setHoveredPressure(false)}
          className="leftsidemenulist-btns"
        >
          <FontAwesomeIcon
            size="1x"
            icon={faLayerGroup}
            className="leftside-icon"
          />
        </div>
        {theme === "light" && (
          <div
            className={
              isCheckedPressure
                ? "leftsidemenulist-btn-tooltip-clicked-light"
                : hoveredPressure
                ? "leftsidemenulist-btn-tooltip-hover-light"
                : "leftsidemenulist-btn-tooltip-light"
            }
            onMouseEnter={() => setHoveredPressure(true)}
            onMouseLeave={() => setHoveredPressure(false)}
          >
            Pressure
          </div>
        )}
        {theme !== "light" && (
          <div
            className={
              isCheckedPressure
                ? "leftsidemenulist-btn-tooltip-clicked"
                : hoveredPressure
                ? "leftsidemenulist-btn-tooltip-hover"
                : "leftsidemenulist-btn-tooltip"
            }
            onMouseEnter={() => setHoveredPressure(true)}
            onMouseLeave={() => setHoveredPressure(false)}
          >
            Pressure
          </div>
        )}
        {hoveredPressure && (
          <label
            onMouseEnter={() => setHoveredPressure(true)}
            onMouseLeave={() => setHoveredPressure(false)}
            className="switch"
          >
            <input
              type="checkbox"
              role="switch"
              checked={isCheckedPressure}
              onChange={handleChangePressureToggle}
            />
            <div className="switch-labels"></div>
          </label>
        )}
      </div>
    </>
  );
};

export default Pressure;
